import { render, staticRenderFns } from "./Faltan.vue?vue&type=template&id=ca0e8676&scoped=true"
import script from "./Faltan.vue?vue&type=script&lang=js"
export * from "./Faltan.vue?vue&type=script&lang=js"
import style0 from "./Faltan.vue?vue&type=style&index=0&id=ca0e8676&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca0e8676",
  null
  
)

export default component.exports